import { defineMessages } from 'react-intl';

const messages = defineMessages({
    skipLinkText: {
        id:'skipLinkText',
        defaultMessage: 'Skip to main content',
        description: 'Text for the skip link.',
    },
    defaultPageTitle: {
        id:'defaultPageTitle',
        defaultMessage: 'LabXchange',
        description: 'Default value for the HTML title attribute',
    },
    pageTitlePlaceholder: {
        id:'pageTitlePlaceholder',
        defaultMessage: '{title} - LabXchange',
        description: 'Placeholder for the value of the HTML title attribute',
    },
    showMoreResults: {
        id:'showMoreResults',
        defaultMessage: 'Show more results',
        description: 'Text for the infinite scroll button.',
    },
    srPageNavigationAnnouncement: {
        id:'srPageNavigationAnnouncement',
        defaultMessage: 'Navigated to {pageTitle}',
        description: 'Announcement read out by the screen reader when user navigates to a different page.',
    },
    uiAbout: {
        id:'uiAbout',
        defaultMessage: 'About',
        description: 'Text for the nav link to the about page.',
    },
    uiBrowse: {
        id:'uiBrowse',
        defaultMessage: 'Browse',
        description: 'Text for Browse menu',
    },
    uiError: {
        id:'uiError',
        defaultMessage: 'Error',
        description: 'Title text shown when some sort of error has occurred.',
    },
    uiHeaderNavBarBrand: {
        id:'uiHeaderNavBarBrand',
        defaultMessage: 'LabXchange',
        description: 'Title for Navbar.',
    },
    uiLoading: {
        id:'uiLoading',
        defaultMessage: 'Loading…',
        description: 'Text shown when content is loading',
    },
    uiLogOut: {
        id:'uiLogOut',
        defaultMessage: 'Log out',
        description: 'Text for log out button in navbar.',
    },
    uiMessagesLinkTitle: {
        id:'uiMessagesLinkTitle',
        defaultMessage: 'Messages',
        description: 'Title attribute for the messages link in the header',
    },
    uiMore: {
        id:'uiMore',
        defaultMessage: 'more',
        description: 'Button/link to expand a block of truncated text to show it in full.',
    },
    uiMoreInfo: {
        id:'uiMoreInfo',
        defaultMessage: 'More information',
        description: 'Label for the link that provides more information',
    },
    uiMyMessages: {
        id:'uiMyMessages',
        defaultMessage: 'Messages',
        description: 'Text for the Messages nav link.',
    },
    uiMyNotifications: {
        id:'uiMyNotifications',
        defaultMessage: 'Notifications',
        description: 'Text for the Notifications nav link.',
    },
    uiNavClasses: {
        id:'uiNavClasses',
        defaultMessage: 'Classes',
        description: 'Text for the Classes forums nav link.',
    },
    uiNavDashboard: {
        id:'uiNavDashboard',
        defaultMessage: 'Dashboard',
        description: 'Text for the Dashboard nav link.',
    },
    uiNavCommunity: {
        id: 'uiNavCommunity',
        defaultMessage: 'Community',
        description: 'Text for the Community nav link.',
    },
    uiNavExplore: {
        id:'uiNavExplore',
        defaultMessage: 'Explore',
        description: 'Text for the Explore nav link.',
    },
    uiNavDiscussions: {
        id:'uiNavDiscussions',
        defaultMessage: 'Discussions',
        description: 'Text for the Discussion forums nav link.',
    },
    uiNavLibrary: {
        id:'uiNavLibrary',
        defaultMessage: 'Library',
        description: 'Text for the Library nav link.',
    },
    uiNavPeople: {
        id:'uiNavPeople',
        defaultMessage: 'People',
        description: 'Text for the People nav link.',
    },
    uiNavSearch: {
        id:'uiNavSearch',
        defaultMessage: 'Search library, people and organizations',
        description: 'Placeholder text for the Search box.',
    },
    uiNavUiDemos: {
        id:'uiNavUiDemos',
        defaultMessage: 'UI Demos',
        description: '(for development only)',
    },
    uiNavSearchButton: {
        id:'uiNavSearchButton',
        defaultMessage: 'Search',
        description: 'Label for the search button in the header',
    },
    uiNext: {
        id:'uiNext',
        defaultMessage: 'Next',
        description: 'Label for a button that moves the user to the next item',
    },
    uiOk: {
        id:'uiOk',
        defaultMessage: 'OK',
        description: 'Label for an OK button to agree/dismiss an alert on the screen',
    },
    uiNotificationsButtonTitle: {
        id:'uiNotificationsButtonTitle',
        defaultMessage: 'Notifications',
        description: 'Title attribute for the notifications button in the header',
    },
    uiNotificationsSR: {
        id:'uiNotificationsSR',
        defaultMessage: 'You have {count, number} {count, plural, one {notification} other {notifications}}.',
        description: 'Screen reader text for notifications icon',
    },
    uiPrevious: {
        id:'uiPrevious',
        defaultMessage: 'Previous',
        description: 'Label for a button that moves the user to the previou item',
    },
    uiProfileSettings: {
        id:'uiProfileSettings',
        defaultMessage: 'Profile Settings',
        description: 'Profile settings link on sidebar',
    },
    uiSave: {
        id:'uiSave',
        defaultMessage: 'Save',
        description: 'A button to save changes',
    },
    uiShowLess: {
        id:'uiShowLess',
        defaultMessage: 'Show less',
        description: 'Button/link to toggle visibility of a block of content',
    },
    uiShowMore: {
        id:'uiShowMore',
        defaultMessage: 'Show more',
        description: 'Button/link to toggle visibility of a block of content',
    },
    uiSidebarLoginMessage: {
        id: 'uiSidebarLoginMessage',
        defaultMessage: 'Welcome back,',
        description: 'Welcome message to display in sidebar on mobile.  The user\'s name is displayed under this message.',
    },
    uiSignIn: {
        id:'uiSignIn',
        defaultMessage: 'Log in',
        description: 'Text for sign in buttons.',
    },
    uiSignUp: {
        id:'uiSignUp',
        defaultMessage: 'Sign up',
        description: 'Text for sign up buttons.',
    },
    uiSuccess: {
        id:'uiSuccess',
        defaultMessage: 'Success',
        description: 'Title text shown when displaying a success message to the user.',
    },
    uiViewProfile: {
        id:'uiViewProfile',
        defaultMessage: 'View profile',
        description: 'Text for button that links to user profile.',
    },
    uiMyProfile: {
        id:'uiMyProfile',
        defaultMessage: 'My profile',
        description: 'Text for my Profile link in user menu in header.',
    },
    uiBookmarks: {
        id:'uiBookmarks',
        defaultMessage: 'Bookmarks',
        description: 'Text for Bookmarks link in user menu in header.',
    },
    uiSettings: {
        id: 'uiSettings',
        defaultMessage: 'Account settings',
        description: 'Text for Settings link in user menu in header.',
    },
    uiWarning: {
        id:'uiWarning',
        defaultMessage: 'Warning',
        description: 'Title text shown when displaying a warning to the user.',
    },
    uiConfirmationButton: {
        id:'uiConfirmationButton',
        defaultMessage: 'Confirm',
        description: 'Confirmation button.',
    },
    uiCancelButton: {
        id:'uiCancelButton',
        defaultMessage: 'Cancel',
        description: 'Cancel button.',
    },
    uiAddButton: {
        id:'uiAddButton',
        defaultMessage: 'Add item',
        description: 'Title of the Add Item card button.',
    },
    uiSelectButton: {
        id:'uiSelectButton',
        defaultMessage: 'Select',
        description: 'Title of the Select button',
    },
    uiUnselectButton: {
        id:'uiUnselectButton',
        defaultMessage: 'Unselect',
        description: 'Title of the unselect button',
    },
    uiCopyrightAgreement: {
        id:'uiCopyrightAgreement',
        defaultMessage: 'I agree to the LabXchange {termsOfService} and {privacyPolicy}.',
        description: 'Text for copyright agreement',
    },
    uiSetLanguage: {
        id: 'uiSetLanguage',
        defaultMessage: 'Set Language',
        description: 'Text for button to open the language picker to change the app language.',
    },
    loginStatusError: {
        id: 'loginStatusError',
        defaultMessage: 'Error updating login status.',
        description: 'Error message when an unknown error is seen when requesting logged in status.',
    },
    loginClassTitle: {
        id:'loginClassTitle',
        defaultMessage: 'Account required',
        description: 'Title text for the login modal',
    },
    uiUnlimited: {
        id: 'uiUnlimited',
        defaultMessage: 'Unlimited',
        description: 'Label for an option choice when a limit is not set (eg. number of attempts: 1, 2, ..., Unlimited)',
    },
    uiAccountRequiredMessage: {
        id: 'uiAccountRequiredMessage',
        defaultMessage: 'You need to log in or create an account to continue. Would you like to do that now?',
        description: 'Message shown to the user when they need to login'
    },
    transcriptEditorTranscriptsSectionLabel: {
        id:'transcriptEditorTranscriptsSectionLabel',
        defaultMessage: 'Transcripts',
        description: 'Label for the "Transcripts" section of the video edit page',
    },
    uiEdit: {
        id: 'uiEdit',
        defaultMessage: 'Edit',
        description: 'label on a button to edit something.',
    },
    uiDone: {
        id: 'uiDone',
        defaultMessage: 'Done',
        description: 'label on a button to complete something.',
    },
    uiDefaultAnswerCorrectToggle: {
        id: 'annotationEditorQuestionCorrectSwitchLabel', /// I used this id to get the previous translations
        defaultMessage: 'Correct',
        description: 'Default label for the correct part of an answer toggle',
    },
    uiDefaultAnswerWrongToggle: {
        id: 'annotationEditorQuestionWrongSwitchLabel', /// I used this id to get the previous translations
        defaultMessage: 'Wrong',
        description: 'Default label for the wrong part of an answer toggle',
    },
    searchButtonLabel: {
        id:'searchButtonLabel',
        defaultMessage: 'Search',
        description: 'Search button (accessible caption for screen readers)',
    },
});

export default messages;
